import React, { FC } from "react";
import classNames from "classnames";
import { useSwipeable } from "react-swipeable";
import { GatsbyImage } from "gatsby-plugin-image";
import { getGatsbyImage } from "gatsby-plugin-storyblok-image";
import { Slide } from "@app/components/base-page/components/side-image-slides/types";

type Props = {
  data: Slide[];
  activeSlide: number;
  onNextSlideSwitch: () => void;
  onPreviousSlideSwitch: () => void;
};

export const Slides: FC<Props> = ({
  data,
  activeSlide,
  onNextSlideSwitch,
  onPreviousSlideSwitch,
}) => {
  const handlers = useSwipeable({
    onSwipedLeft: onNextSlideSwitch,
    onSwipedRight: onPreviousSlideSwitch,
  });

  return (
    <div
      className={classNames(
        "relative aspect-[9/7] w-full",
        "lg:aspect-[17/10]",
        "xl:aspect-[9/7]",
      )}
      {...handlers}
    >
      {data.map((slide, index) => (
        <div
          key={slide._uid}
          className={classNames(
            "absolute top-0 right-0 bottom-0 left-0 w-full transform-3d",
          )}
        >
          <GatsbyImage
            image={getGatsbyImage(slide.media.filename, {
              layout: "fullWidth",
            })}
            alt={slide.media.alt}
            className={classNames(
              "border-divider aspect-[9/7] w-full translate-z-0 rounded-lg border border-solid duration-700",
              "lg:aspect-[17/10]",
              "xl:aspect-[9/7]",
              {
                "opacity-100": index === activeSlide,
                "opacity-0": index !== activeSlide,
              },
            )}
            loading="eager"
          />
        </div>
      ))}
    </div>
  );
};
